import React from "react";
import styles from "./RoundFilterButton.module.scss";
import classNames from "classnames";

const RoundFilterButton = ({ children, count, isActive, isDisabled, onClick }) => {
    return <button className={classNames(styles.base, {[styles['is-active']]: isActive})} onClick={onClick} disabled={isDisabled} onMouseDown={e=>e.preventDefault()}>
        {children}
        {!!count && <span>({count})</span>}
    </button>
}

export default RoundFilterButton;